import React from 'react';
import PropTypes from 'prop-types';
import { Button, ButtonGroup } from '@pattern-library/buttons';
import TextInput from '@pattern-library/text-input';
import { ReactDatePicker } from '@pattern-library/datepicker';
import useUnifiedLoginFormValidation from '../../hooks/useUnifiedLoginFormValidation';

const propTypes = {
    buttonProps: PropTypes.objectOf(PropTypes.string).isRequired,
    datePickerProps: PropTypes.objectOf(
        PropTypes.oneOfType([PropTypes.string, PropTypes.object, PropTypes.array])
    ).isRequired,
    zipProps: PropTypes.objectOf(PropTypes.oneOfType([PropTypes.string, PropTypes.array]))
        .isRequired,
    formAction: PropTypes.string.isRequired,
    antiForgeryToken: PropTypes.string.isRequired,
    ssn: PropTypes.string.isRequired
};

function ForgotUserIdPromptForInfoForm(props) {
    const { buttonProps, datePickerProps, zipProps, formAction, antiForgeryToken, ssn } = props;

    const datepickerInputName = datePickerProps.inputProps.name;
    const zipInputName = zipProps.name;
    const { validation: datePickerInputValidation, ...restDatepickerInputProps } = datePickerProps;
    const { validation: zipInputValidation, ...restZipInputProps } = zipProps;

    /**
     * @type { import('@pattern-library/base/dist/js/hooks/useFormValidation').FormValidationSchema}
     */
    const schema = {
        [datepickerInputName]: [
            ...datePickerInputValidation,
            {
                validationMethod: value => /^\d{1,2}\/\d{1,2}\/\d{4}$/.test(value),
                errorMessage: 'Please enter a valid date format (mm/dd/yyyy).'
            }
        ],
        [zipInputName]: zipInputValidation
    };

    const { hasError, onSubmit, errorMessage } = useUnifiedLoginFormValidation({ schema });

    return (
        <div className="ul-login-form">
            <form
                action={formAction}
                method="post"
                onSubmit={onSubmit}
                autoComplete="off"
                noValidate
            >
                <div dangerouslySetInnerHTML={{ __html: antiForgeryToken }} />
                <input type="hidden" id="ssn" name="Ssn" value={ssn} />
                <ReactDatePicker
                    isRequired
                    displayCustomError={hasError(datepickerInputName)}
                    customErrorMessage={errorMessage(datepickerInputName)}
                    groupClass="asc-mtb-3"
                    {...restDatepickerInputProps}
                />
                <TextInput
                    isRequired
                    hasError={hasError(zipInputName)}
                    errorMessage={errorMessage(zipInputName)}
                    {...restZipInputProps}
                />
                <ButtonGroup alignment="center" className="asc-mt-4 asc-mb-0">
                    <Button type="submit" className="asc-mtb-0" {...buttonProps} />
                </ButtonGroup>
            </form>
        </div>
    );
}

ForgotUserIdPromptForInfoForm.propTypes = propTypes;
export default ForgotUserIdPromptForInfoForm;
